export default {
  loadBreakdownItems (objectClass, filters, queries) {
    return this.sendRequest('/gorilla/breakdown/' + objectClass, filters, queries)
  }
}
